import { combineReducers } from 'redux';
import readEvents from './events';

const rootReducer = combineReducers({
    readEvents: readEvents,
});

export default rootReducer;